<template>
	<div :class="[seType,{'open':open},serSplit]">
		<template v-if="!!split">
			<button type="button" class="btn" :class="[setBtn,setSize]">{{dropname}}</button>
			<button class="btn dropdown-toggle" :class="[setBtn,setSize]" type="button" @click="openDropd" ref="button">			
			<span class="caret"></span>
  		</button>
		</template>
		<template v-else>
			<button class="btn dropdown-toggle" :class="[setBtn,setSize]" type="button" @click="openDropd" ref="button">
				{{dropname}}
				<span class="caret"></span>
  			</button>
		</template>
		<ul class="dropdown-menu">
			<li v-for="(menu,index) in formatted" @click="setName(menu,index)" :class="{active:isActive==index}">
				<span>{{menu.name}}</span>
			</li>
		</ul>
	</div>
</template>

<script>
	import lib from "../../assets/js/lib.js"
	export default {
		name: 'bsf-dropdown',
		components: {},
		props: {
			btype: {
				type: [String, Array],
			},
			dpname: {
				type: String,
				default: "请在下面列表中选择"
			},
			up: {
				type: Boolean,
				default: false
			},
			data: Array,
			dname: String,
			dval: String,
			split: {
				type: Boolean,
				default: false
			},
			inline: {
				type: Boolean,
				default: false
			},
			bsize: [String, Array],
		},
		data() {
			return {
				open: false,
				dropname: this.dpname,
				isActive: null
			}
		},
		methods: {
			openDropd() {
				this.open = !this.open;
			},
			setName(menu, i) {
				this.dropname = menu.name;
				this.open = false;
				this.isActive = i;
				this.$emit('selected', menu.val)
			}
		},
		mounted: function() {
			document.addEventListener('click', (e) => {
				if(!lib.contains(this.$refs.button, e.target)) {
					this.open = false
				}
			})
			//			this.$nextTick(function() {
			//
			//			})
		},
		computed: {
			seType() {
				return this.up ? "dropup" : "dropdown"
			},
			formatted() {
				let data = [];
				this.data.forEach(menu => {
					data.push({
						name: menu[this.dname],
						val: menu[this.dval]
					})
				})
				return data
			},
			serSplit() {
				return this.split || this.inline ? "btn-group" : ""
			},
			setSize() {
				return this.bsize ? "btn-" + this.bsize : ""
			},
			setBtn() {
				return this.btype ? 'btn-' + this.btype : "btn-default"
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.dropdown,
	.dropup {
		.btn:not(.btn-default)+.dropdown-menu {
			li>span {
				&:hover {
					color: @cwh;
				}
			}
		}
		.btn-ces+.dropdown-menu {
			li {
				&.active {
					>span {
						background-color: @ces;
					}
				}
				>span {
					&:hover {
						background-color: @ces;
					}
				}
			}
		}
		.btn-default+.dropdown-menu {
			li {
				&.active {
					>span {
						background-color: @bgc;
						color: inherit;
					}
				}
				>span {
					&:hover {
						background-color: @bgc;
					}
				}
			}
		}
		.btn-danger+.dropdown-menu {
			li {
				&.active {
					>span {
						background-color: @cre;
					}
				}
				>span {
					&:hover {
						background-color: @cre;
					}
				}
			}
		}
		.btn-primary+.dropdown-menu {
			li {
				&.active {
					>span {
						background-color: @cbl1;
					}
				}
				>span {
					&:hover {
						background-color: @cbl1;
					}
				}
			}
		}
		.btn-success+.dropdown-menu {
			li {
				&.active {
					>span {
						background-color: @cgr;
					}
				}
				>span {
					&:hover {
						background-color: @cgr;
					}
				}
			}
		}
		.btn-info+.dropdown-menu {
			li {
				&.active {
					>span {
						background-color: @cbl;
					}
				}
				>span {
					&:hover {
						background-color: @cbl;
					}
				}
			}
		}
		.btn-warning+.dropdown-menu {
			li {
				&.active {
					>span {
						background-color: @cye;
					}
				}
				>span {
					&:hover {
						background-color: @cye;
					}
				}
			}
		}
	}
	
	.dropdown-menu {
		.btn-group & {
			min-width: 100%;
		}
		>li {
			&.active {
				span {
					background-color: @ces;
					color: @cwh;
				}
			}
			>span {
				display: block;
				padding: 3px 20px;
				clear: both;
				font-weight: 400;
				line-height: 1.42857143;
				color: #333;
				white-space: nowrap;
				cursor: pointer;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// dropdown.vue?e883730a